
import { defineComponent } from "vue";
import AppButton from "@/common/components/AppButton.vue";

export default defineComponent({
  components: { AppButton },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
  },
});
